import axios from "axios";
import React, { useEffect, useState } from "react";
import { Config } from "../../../../../Config";
import ApplicationStatusChart from "./Components/ApplicationStatusChart";
import DataTable from "./Components/DataTable";
import FilterBarChart from "./Components/FilterBarChart";
import MobileFilterMenu from "./Components/MobileFilterMenu";
import StatusTable from "./Components/StatusTable";
import Summary from "./Components/Summary";

const HRAdminDashboard = (props) => {
  const [PosApplicationCount, setPosApplicationCount] = useState(0);
  const [ProjApplicationCount, setProjApplicationCount] = useState(0);
  const [ActApplicationCount, setActApplicationCount] = useState(0);
  const [AcceptedJobsCount, setAcceptedJobsCount] = useState(0);
  const [AcceptedProjectsCount, setAcceptedProjectsCount] = useState(0);
  const [AcceptedActivitiesCount, setAcceptedActivitiesCount] = useState(0);
  const [JobsThresholds, setJobsThresholds] = useState();
  const [ProjectsThresholds, setProjectsThresholds] = useState();
  const [ActivitiesThresholds, setActivitiesThresholds] = useState();
  const [SelectedJPAType, setSelectedJPAType] = useState("Vacancies");
  const [SelectedJPAStatus, setSelectedJPAStatus] = useState("");
  const [SelectedEnum, setSelectedEnum] = useState("");
  const [StatusIsActive, setStatusIsActive] = useState(false); // determines if the filters on the status chart have been selected (used for displaying table)
  const [Locations, setLocations] = useState();
  const [Languages, setLanguages] = useState();
  const [AvailableJobsCount, setAvailableJobsCount] = useState(0);
  const [AvailableProjectsCount, setAvailableProjectsCount] = useState(0);
  const [AvailableActivitiesCount, setAvailableActivitiesCount] = useState(0);
  const [AllJobsCount, setAllJobsCount] = useState(0);
  const [AllProjectsCount, setAllProjectsCount] = useState(0);
  const [AllActivitiesCount, setAllActivitiesCount] = useState(0);
  const [TableIsEmpty, setTableIsEmpty] = useState(false);
  const [StatusTableIsEmpty, setStatusTableIsEmpty] = useState(false);
  const [TableData, setTableData] = useState([]);
  const [FilterCriteria, setFilterCriteria] = useState(); // filter barchart data
  const [TotalElements, setTotalElements] = useState();
  const [MobileFilterIsOpen, setMobileFilterIsOpen] = useState(false);
  const [ActiveFilterCount, setActiveFilterCount] = useState(0); // only displayed and used on mobile
  const [JPASortIds] = useState([
    "location-up",
    "location-down",
    "language-up",
    "language-down",
    "like-up",
    "like-down",
    "dislike-up",
    "dislike-down",
    "bookmark-up",
    "bookmark-down",
    "application-up",
    "application-down",
  ]);
  const [StatusSortIds] = useState([
    "location-up",
    "location-down",
    "language-up",
    "language-down",
    "application-up",
    "application-down",
  ]);
  const [ChartBtnIds] = useState(["jobs-btn", "proj-btn", "act-btn"]);
  const [AppStatusChartBtnIds] = useState([
    "not-started",
    "new",
    "in-progress",
    "accepted",
    "popular",
  ]);
  const [StatusEnums] = useState([
    { id: "not-started", enum: "NOT_STARTED" },
    { id: "new", enum: "NEW" },
    { id: "in-progress", enum: "IN_PROGRESS" },
    { id: "accepted", enum: "ACCEPTED" },
    { id: "popular", enum: "POPULAR" },
  ]);
  const [JobsStatusChartData, setJobsStatusChartData] = useState(); // ["Not started", "New", "In progress", "Accepted", "Popular"]
  const [ProjectsStatusChartData, setProjectsStatusChartData] = useState(); // ["Not started", "New", "In progress", "Accepted", "Popular"]
  const [ActivitiesStatusChartData, setActivitiesStatusChartData] = useState(); // ["Not started", "New", "In progress", "Accepted", "Popular"]
  const [ResetIsActive, setResetIsActive] = useState(false);
  const [FilterJPA, setFilterJPA] = useState('')
  const [FilterHiringManager, setFilterHiringManager] = useState('')

  useEffect(() => {
    fetchPosCountSummary();
    fetchProjCountSummary();
    fetchActCountSummary();

    fetchAcceptedJobsCount();
    fetchAcceptedProjectsCount();
    fetchAcceptedActivitiesCount();

    fetchAllJobsCount();
    fetchAllProjectsCount();
    fetchAllActivitiesCount();

    getJobsThreshold();
    getProjectsThreshold();
    getActivitiesThreshold();

    fetchLocations();
    fetchLanguages();

    getSingleBarChartData(true);
    getStatusChartData();
  }, []);

  useEffect(() => {
    const debounceId = setTimeout(() => {
      const criteria = {
        ...FilterCriteria,
        hrFullNameLike: FilterHiringManager,
        titleLike: FilterJPA
      }

      setFilterCriteria(prev => ({
        ...prev,
        hrFullNameLike: FilterHiringManager,
        titleLike: FilterJPA
      }))

      if (StatusIsActive) {
        fetchStatusTableData(5, 0, SelectedJPAType, SelectedEnum, false, criteria)
      } else {
        fetchAvailableJPATableData(5, 0, SelectedJPAType, false, criteria)
      }
    }, 500)

    return () => clearTimeout(debounceId)
  }, [FilterJPA, FilterHiringManager])

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const switchSortType = (Type) => {
    if (Type === "jpa") {
      return "title";
    } else if (Type === "location") {
      return "workCity";
    } else if (Type === "language") {
      return "languages";
    } else if (Type === "like") {
      return "totalLikes";
    } else if (Type === "dislike") {
      return "totalDislikes";
    } else if (Type === "bookmark") {
      return "totalBookmarks";
    } else if (Type === "application") {
      return "totalApplications";
    }
  };

  const switchStatusSortType = (Type) => {
    if (Type === "jpa") {
      return "title";
    } else if (Type === "location") {
      return "workCity";
    } else if (Type === "language") {
      return "languages";
    } else if (Type === "application") {
      return "count";
    }
  };

  const switchSortDirection = (Direction) => {
    if (Direction === "up") {
      return "ASC";
    } else {
      return "DESC";
    }
  };

  const getStatusChartData = () => {
    getJobsChartData();
    getProjectsChartData();
    getActivitiesChartData();
  };

  const fetchAllJobsCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAllJobsCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAllProjectsCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAllProjectsCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAllActivitiesCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAllActivitiesCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getJobsChartData = () => {
    let Values = [0, 0, 0, 0, 0];

    let ReqNotStarted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[0].enum,
        },
      },
    };
    let ReqNew = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[1].enum,
        },
      },
    };
    let ReqInProgress = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[2].enum,
        },
      },
    };
    let ReqAccepted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[3].enum,
        },
      },
    };
    let ReqPopular = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[4].enum,
        },
      },
    };

    axios(ReqNotStarted)
      .then((Res) => {
        console.log(Res);
        Values[0] = Res.data.value;
        axios(ReqNew)
          .then((Res) => {
            console.log(Res);
            Values[1] = Res.data.value;
            axios(ReqInProgress)
              .then((Res) => {
                console.log(Res);
                Values[2] = Res.data.value;
                axios(ReqAccepted)
                  .then((Res) => {
                    console.log(Res);
                    Values[3] = Res.data.value;
                    axios(ReqPopular)
                      .then((Res) => {
                        console.log(Res);
                        Values[4] = Res.data.value;
                        setJobsStatusChartData(Values);
                      })
                      .catch((Err) => {
                        console.log(Err.response);
                      });
                  })
                  .catch((Err) => {
                    console.log(Err.response);
                  });
              })
              .catch((Err) => {
                console.log(Err.response);
              });
          })
          .catch((Err) => {
            console.log(Err.response);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const getProjectsChartData = () => {
    let Values = [0, 0, 0, 0, 0];

    let ReqNotStarted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[0].enum,
        },
      },
    };
    let ReqNew = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[1].enum,
        },
      },
    };
    let ReqInProgress = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[2].enum,
        },
      },
    };
    let ReqAccepted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[3].enum,
        },
      },
    };
    let ReqPopular = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[4].enum,
        },
      },
    };

    axios(ReqNotStarted)
      .then((Res) => {
        console.log(Res);
        Values[0] = Res.data.value;
        axios(ReqNew)
          .then((Res) => {
            console.log(Res);
            Values[1] = Res.data.value;
            axios(ReqInProgress)
              .then((Res) => {
                console.log(Res);
                Values[2] = Res.data.value;
                axios(ReqAccepted)
                  .then((Res) => {
                    console.log(Res);
                    Values[3] = Res.data.value;
                    axios(ReqPopular)
                      .then((Res) => {
                        console.log(Res);
                        Values[4] = Res.data.value;
                        setProjectsStatusChartData(Values);
                      })
                      .catch((Err) => {
                        console.log(Err.response);
                      });
                  })
                  .catch((Err) => {
                    console.log(Err.response);
                  });
              })
              .catch((Err) => {
                console.log(Err.response);
              });
          })
          .catch((Err) => {
            console.log(Err.response);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const getActivitiesChartData = () => {
    let Values = [0, 0, 0, 0, 0];

    let ReqNotStarted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[0].enum,
        },
      },
    };
    let ReqNew = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[1].enum,
        },
      },
    };
    let ReqInProgress = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[2].enum,
        },
      },
    };
    let ReqAccepted = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[3].enum,
        },
      },
    };
    let ReqPopular = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: {
        criteria: {
          status: StatusEnums[4].enum,
        },
      },
    };

    axios(ReqNotStarted)
      .then((Res) => {
        console.log(Res);
        Values[0] = Res.data.value;
        axios(ReqNew)
          .then((Res) => {
            console.log(Res);
            Values[1] = Res.data.value;
            axios(ReqInProgress)
              .then((Res) => {
                console.log(Res);
                Values[2] = Res.data.value;
                axios(ReqAccepted)
                  .then((Res) => {
                    console.log(Res);
                    Values[3] = Res.data.value;
                    axios(ReqPopular)
                      .then((Res) => {
                        console.log(Res);
                        Values[4] = Res.data.value;
                        setActivitiesStatusChartData(Values);
                      })
                      .catch((Err) => {
                        console.log(Err.response);
                      });
                  })
                  .catch((Err) => {
                    console.log(Err.response);
                  });
              })
              .catch((Err) => {
                console.log(Err.response);
              });
          })
          .catch((Err) => {
            console.log(Err.response);
          });
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const fetchStatusTableData = (Size, Start, JPAType, ENUM, IsInitial, Criteria) => {
    setStatusTableIsEmpty(false);

    if (JPAType === "") {
      JPAType = "Vacancies";
    }

    // Defining the request data
    let Data = {
      criteria: {
        ...Criteria,
        status: ENUM,
      },
      start: Start,
      size: Size,
      sorts: [
        {
          direction: "ASC",
          fieldName: "title",
        },
      ],
    };
    // dynamic request URL based on JPA type selected from bar charts
    var ReqURL;
    if (JPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status/detail";
    } else if (JPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status/detail";
    } else if (JPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status/detail";
    }

    if (!IsInitial) {
      //handling the selected sort item
      let ActiveSortId;
      StatusSortIds.map((Sort) => {
        if (
          document.getElementById(Sort) &&
          document.getElementById(Sort).classList.contains("active-pointer")
        ) {
          ActiveSortId = Sort;
        } else if (document.getElementById(Sort) === null) {
          ActiveSortId = "jpa-up";
        }
      });

      if (!ActiveSortId) {
        ActiveSortId = "jpa-up"
      }

      let IndexToSlice = ActiveSortId.indexOf("-");
      let SortType = ActiveSortId.slice(0, IndexToSlice);
      let SortDirection = ActiveSortId.slice(
        IndexToSlice + 1,
        ActiveSortId.length
      );

      let Sort = {
        direction: switchSortDirection(SortDirection),
        fieldName: switchStatusSortType(SortType),
      };
      Data.sorts[0] = Sort;
    }

    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTableData(Res.data.results);
        setTotalElements(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          setStatusTableIsEmpty(true);
        }
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const fetchAvailableJPATableData = (
    Size,
    Start,
    JPAType,
    IsInitial,
    Criteria
  ) => {
    // Defining the request data
    let Data = {
      start: Start,
      size: Size,
      sorts: [
        {
          direction: "ASC",
          fieldName: "title",
        },
      ],
    };
    if (Criteria) {
      Data.criteria = Criteria;
    } else if (FilterCriteria !== undefined) {
      Data.criteria = FilterCriteria;
    }
    // dynamic request URL based on JPA type selected from bar charts
    var ReqURL;
    if (JPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa/detail";
    } else if (JPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-available-jpa/detail";
    } else if (JPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-available-jpa/detail";
    }

    if (!IsInitial) {
      //handling the selected sort item
      let ActiveSortId;
      JPASortIds.map((Sort) => {
        if (
          document.getElementById(Sort) &&
          document.getElementById(Sort).classList.contains("active-pointer")
        ) {
          ActiveSortId = Sort;
        } else if (document.getElementById(Sort) === null) {
          ActiveSortId = "jpa-up";
        }
      });

      if (!ActiveSortId) {
        ActiveSortId = "jpa-up";
      }

      let IndexToSlice = ActiveSortId.indexOf("-");
      let SortType = ActiveSortId.slice(0, IndexToSlice);
      let SortDirection = ActiveSortId.slice(
        IndexToSlice + 1,
        ActiveSortId.length
      );

      let Sort = {
        direction: switchSortDirection(SortDirection),
        fieldName: switchSortType(SortType),
      };
      Data.sorts[0] = Sort;
    }

    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setTableData(Res.data.results);
        setTotalElements(Res.data.totalElements);
        if (Res.data.results.length === 0) {
          setTableIsEmpty(true);
        } else {
          setTableIsEmpty(false);
        }
        // pagination and summary numbers information
        if (document.getElementById("end") && Res.data.totalElements < Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
          document
            .getElementById("next-page")
            .classList.add("page-btn-disabled");
        } else if (
          document.getElementById("end") &&
          Res.data.totalElements > Size
        ) {
          document.getElementById("end").innerHTML = Start + Size;
          document
            .getElementById("next-page")
            .classList.remove("page-btn-disabled");
        }
        if (Res.data.totalElements < Start + Size) {
          document.getElementById("end").innerHTML = Res.data.totalElements;
        }
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getSingleBarChartData = (IsInitial) => {
    var LikesThreshold;
    var BookmarksThreshold;
    var AppThreshold;

    if (
      JobsThresholds !== undefined &&
      ProjectsThresholds !== undefined &&
      ActivitiesThresholds !== undefined
    ) {
      LikesThreshold = Math.max(
        JobsThresholds.maxlikes,
        ProjectsThresholds.maxlikes,
        ActivitiesThresholds.maxlikes
      );
      BookmarksThreshold = Math.max(
        JobsThresholds.maxbookmarks,
        ProjectsThresholds.maxbookmarks,
        ActivitiesThresholds.maxbookmarks
      );
      AppThreshold = Math.max(
        JobsThresholds.maxapps,
        ProjectsThresholds.maxapps,
        ActivitiesThresholds.maxapps
      );
    }

    let Data;
    if (IsInitial) {
      Data = {};
    } else {
      Data = {
        criteria: {},
      };
      if (
        parseInt(document.getElementById("likes-max").innerHTML) !==
          LikesThreshold ||
        parseInt(document.getElementById("likes-min").innerHTML) !== 0
      ) {
        Data.criteria.numberOfLikes = {
          maxValue: parseInt(document.getElementById("likes-max").innerHTML),
          minValue: parseInt(document.getElementById("likes-min").innerHTML),
        };
      }

      if (
        parseInt(document.getElementById("bookmarks-max").innerHTML) !==
          BookmarksThreshold ||
        parseInt(document.getElementById("bookmarks-min").innerHTML) !== 0
      ) {
        Data.criteria.numberOfBookmarks = {
          maxValue: parseInt(
            document.getElementById("bookmarks-max").innerHTML
          ),
          minValue: parseInt(
            document.getElementById("bookmarks-min").innerHTML
          ),
        };
      }

      if (
        parseInt(document.getElementById("apps-max").innerHTML) !==
          AppThreshold ||
        parseInt(document.getElementById("apps-min").innerHTML) !== 0
      ) {
        Data.criteria.numberOfApplications = {
          maxValue: parseInt(document.getElementById("apps-max").innerHTML),
          minValue: parseInt(document.getElementById("apps-min").innerHTML),
        };
      }

      if (FilterHiringManager) {
        Data.criteria.hrFullNameLike = FilterHiringManager;
      }

      if (FilterJPA) {
        Data.criteria.titleLike = FilterJPA;
      }

      // handling the selected locations and languages and putting the selected items in an array
      let SelectedLocations = [];
      Locations.map((Loc) => {
        if (
          document
            .getElementById("icon-" + Loc.id)
            .classList.contains("feather-check-selected")
        ) {
          SelectedLocations.push(Loc.name);
        }
      });
      if (SelectedLocations.length > 0) {
        Data.criteria.locations = SelectedLocations;
      }

      let SelectedLanguages = [];
      Languages.map((Lang) => {
        if (
          document
            .getElementById("icon-" + Lang.id)
            .classList.contains("feather-check-selected")
        ) {
          SelectedLanguages.push(Lang.name);
        }
      });
      if (SelectedLanguages.length > 0) {
        Data.criteria.languages = SelectedLanguages;
      }
    }

    fetchJobsBarChartData(Data);
    fetchProjectsBarChartData(Data);
    fetchActivitiesBarChartData(Data);

    if (!IsInitial) {
      let Size = 5;
      if (document.getElementById("pre-selected-row-per-page") !== null) {
        Size = parseInt(
          document.getElementById("pre-selected-row-per-page").innerHTML
        );
      }
      setFilterCriteria(Data.criteria);
      fetchAvailableJPATableData(
        Size,
        0,
        SelectedJPAType,
        false,
        Data.criteria
      );
    }
  };

  const fetchJobsBarChartData = (Criteria) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Criteria,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAvailableJobsCount(Res.data.value);
      })
      .catch((Err) => console.log(Err.response));
  };
  const fetchProjectsBarChartData = (Criteria) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-available-jpa",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Criteria,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAvailableProjectsCount(Res.data.value);
      })
      .catch((Err) => console.log(Err));
  };
  const fetchActivitiesBarChartData = (Criteria) => {
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-available-jpa",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Criteria,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAvailableActivitiesCount(Res.data.value);
      })
      .catch((Err) => console.log(Err));
  };

  const fetchPosCountSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setPosApplicationCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchProjCountSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProjApplicationCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchActCountSummary = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/all-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setActApplicationCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const fetchAcceptedJobsCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/statistic/accepted-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAcceptedJobsCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAcceptedProjectsCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/statistic/accepted-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAcceptedProjectsCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const fetchAcceptedActivitiesCount = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/statistic/accepted-applications",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setAcceptedActivitiesCount(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const getJobsThreshold = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa/threshold",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setJobsThresholds(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const getProjectsThreshold = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-available-jpa/threshold",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setProjectsThresholds(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const getActivitiesThreshold = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-available-jpa/threshold",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setActivitiesThresholds(Res.data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // Languages are fetched from 3 different services and then the duplicate items are removed
  // and the final array is saved as languages options in component state.
  const fetchLanguages = () => {
    let AllLangs = []; // an array of strings containing duplicate items

    // Position service
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa/language-list",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        Res.data.map((Lang) => {
          AllLangs.push(Lang);
        });
        // Project service
        let Req = {
          method: "GET",
          baseURL:
            window._env_.API_URL +
            Config.ProjectServiceURL +
            "/api/project/dashboard/chart-available-jpa/language-list",
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
          },
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            Res.data.map((Lang) => {
              AllLangs.push(Lang);
            });

            // Activity service
            let Req = {
              method: "GET",
              baseURL:
                window._env_.API_URL +
                Config.ActivityServiceURL +
                "/api/activity/dashboard/chart-available-jpa/language-list",
              headers: {
                Authorization: "Bearer " + window.localStorage.getItem("Token"),
              },
            };
            axios(Req)
              .then((Res) => {
                console.log(Res);
                Res.data.map((Lang) => {
                  AllLangs.push(Lang);
                });

                let NonDuplicateLangs = [...new Set(AllLangs)]; // in form of array of strings

                let Langs = [];
                NonDuplicateLangs.map((Lang) => {
                  Langs.push({
                    name: Lang,
                    id: Lang,
                  });
                });
                setLanguages(Langs);
              })
              .catch((Err) => {
                console.log(Err);
              });
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  // Locations are fetched from 3 different services and then the duplicate items are removed
  // and the final array is saved as location options in component state.
  const fetchLocations = () => {
    let AllLocations = [];

    // position service available locations
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa/location-list",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        Res.data.map((Loc) => {
          AllLocations.push(Loc);
        });
        // project service available locations
        let Req = {
          method: "GET",
          baseURL:
            window._env_.API_URL +
            Config.ProjectServiceURL +
            "/api/project/dashboard/chart-available-jpa/location-list",
          headers: {
            Authorization: "Bearer " + window.localStorage.getItem("Token"),
          },
        };
        axios(Req)
          .then((Res) => {
            console.log(Res);
            Res.data.map((Loc) => {
              AllLocations.push(Loc);
            });
            // activity service available locations
            let Req = {
              method: "GET",
              baseURL:
                window._env_.API_URL +
                Config.ActivityServiceURL +
                "/api/activity/dashboard/chart-available-jpa/location-list",
              headers: {
                Authorization: "Bearer " + window.localStorage.getItem("Token"),
              },
            };
            axios(Req)
              .then((Res) => {
                console.log(Res);
                Res.data.map((Loc) => {
                  AllLocations.push(Loc);
                });
                let NonDuplicateLocations = [...new Set(AllLocations)]; // in form of array of strings

                let Locations = []; // array of objects (because the select elements need id and name as object form)
                NonDuplicateLocations.map((Item, i) => {
                  Locations.push({
                    name: Item,
                    id: "location-" + i,
                  });
                });
                setLocations(Locations);
              })
              .catch((Err) => {
                console.log(Err);
              });
          })
          .catch((Err) => {
            console.log(Err);
          });
      })
      .catch((Err) => {
        console.log(Err);
      });
  };
  const resetTableData = () => {
    setTableData([]);
    setFilterCriteria(undefined);
    setFilterJPA('');
    setFilterHiringManager('');
  };

  const toggleExport = () => {
    let ReqURL;
    if (SelectedJPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-available-jpa/detail/export";
    } else if (SelectedJPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-available-jpa/detail/export";
    } else if (SelectedJPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-available-jpa/detail/export";
    }

    let Req = {
      method: "GET",
      baseURL: ReqURL,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };

    let FileName = "Available_" + SelectedJPAType + ".xlsx";

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", FileName);
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const toggleExportStatus = () => {
    let ReqURL;
    if (SelectedJPAType === "Vacancies") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/dashboard/chart-application-status/detail/export/" +
        SelectedEnum;
    } else if (SelectedJPAType === "Projects") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/dashboard/chart-application-status/detail/export/" +
        SelectedEnum;
    } else if (SelectedJPAType === "Activities") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/dashboard/chart-application-status/detail/export/" +
        SelectedEnum;
    }

    let Req = {
      method: "GET",
      baseURL: ReqURL,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
    };

    let FileName =
      "Application_Status_" +
      SelectedJPAType +
      "_" +
      SelectedEnum.toLocaleLowerCase().replace("_", " ") +
      ".xlsx";

    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute("download", FileName);
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  return (
    <>
      <div className="dashboard-pages-content">
        {window.innerWidth <= 450 &&
        JobsThresholds !== undefined &&
        ProjectsThresholds !== undefined &&
        ActivitiesThresholds !== undefined &&
        Locations !== undefined &&
        Languages !== undefined ? (
          <MobileFilterMenu
            JobsThresholds={JobsThresholds}
            ProjectsThresholds={ProjectsThresholds}
            ActivitiesThresholds={ActivitiesThresholds}
            MaxLikes={
              JobsThresholds.maxlikes +
              ProjectsThresholds.maxlikes +
              ActivitiesThresholds.maxlikes
            }
            MaxBookmarks={
              JobsThresholds.maxbookmarks +
              ProjectsThresholds.maxbookmarks +
              ActivitiesThresholds.maxbookmarks
            }
            MaxApps={
              JobsThresholds.maxapps +
              ProjectsThresholds.maxapps +
              ActivitiesThresholds.maxapps
            }
            AllLanguages={[...Languages]}
            AllLocations={[...Locations]}
            Close={() => setMobileFilterIsOpen(false)}
            SetActiveFilterCount={(Count) => setActiveFilterCount(Count)}
            MobileFilterIsOpen={MobileFilterIsOpen}
            ActiveFilterCount={ActiveFilterCount}
            GetSingleBarChartData={() => getSingleBarChartData()}
            LangData={props.LangData}
          />
        ) : null}
        <Summary
          AllApplicationsCount={
            PosApplicationCount + ProjApplicationCount + ActApplicationCount
          }
          AcceptedJobsCount={AcceptedJobsCount}
          AcceptedProjectsCount={AcceptedProjectsCount}
          AcceptedActivitiesCount={AcceptedActivitiesCount}
          LangData={props.LangData}
          AllJobsCount={AllJobsCount}
          AllProjectsCount={AllProjectsCount}
          AllActivitiesCount={AllActivitiesCount}
        />
        {JobsThresholds === undefined ||
        ProjectsThresholds === undefined ||
        ActivitiesThresholds === undefined ||
        Locations === undefined ||
        Languages === undefined ? null : (
          <FilterBarChart
            LangData={props.LangData}
            JobsThresholds={JobsThresholds}
            ProjectsThresholds={ProjectsThresholds}
            ActivitiesThresholds={ActivitiesThresholds}
            ActiveFilterCount={ActiveFilterCount}
            SetActiveFilterCount={(Count) => setActiveFilterCount(Count)}
            MaxLikes={Math.max(
              JobsThresholds.maxlikes,
              ProjectsThresholds.maxlikes,
              ActivitiesThresholds.maxlikes
            )}
            MaxBookmarks={Math.max(
              JobsThresholds.maxbookmarks,
              ProjectsThresholds.maxbookmarks,
              ActivitiesThresholds.maxbookmarks
            )}
            MaxApps={Math.max(
              JobsThresholds.maxapps,
              ProjectsThresholds.maxapps,
              ActivitiesThresholds.maxapps
            )}
            SaveSelectedJPAType={(SelectedJPAType) =>
              setSelectedJPAType(SelectedJPAType)
            }
            AllLanguages={[...Languages]}
            AllLocations={[...Locations]}
            ChartBtnIds={ChartBtnIds}
            GetSingleBarChartData={() => getSingleBarChartData()}
            AvailableJobs={AvailableJobsCount}
            AvailableProjects={AvailableProjectsCount}
            AvailableActivities={AvailableActivitiesCount}
            FetchData={(Size, Start, JPAType) =>
              fetchAvailableJPATableData(Size, Start, JPAType)
            }
            Clear={() => getSingleBarChartData(true)}
            ResetIsActive={ResetIsActive}
            SetResetIsActive={(Bool) => setResetIsActive(Bool)}
            ResetTableData={() => resetTableData()}
            HandleMobileFilterMenu={() => setMobileFilterIsOpen(true)}
            AppStatusChartBtnIds={AppStatusChartBtnIds}
            SetStatusIsActive={(Bool) => setStatusIsActive(Bool)}
          />
        )}
        {JobsStatusChartData !== undefined &&
        ProjectsStatusChartData !== undefined &&
        ActivitiesStatusChartData !== undefined ? (
          <ApplicationStatusChart
            LangData={props.LangData}
            AppStatusChartBtnIds={AppStatusChartBtnIds}
            BarChartBtnIds={ChartBtnIds}
            SetStatusIsActive={(Bool) => setStatusIsActive(Bool)}
            SaveSelectedStatus={(Enum) => setSelectedEnum(Enum)}
            FetchData={(Size, Start, ENUM) =>
              fetchStatusTableData(Size, Start, SelectedJPAType, ENUM)
            }
            Data={{
              jobs: JobsStatusChartData,
              projects: ProjectsStatusChartData,
              activities: ActivitiesStatusChartData,
            }}
          />
        ) : null}
        {TotalElements === undefined ? null : (
          <>
            {StatusIsActive ? (
              <>
                {SelectedEnum === "" ? null : (
                  <StatusTable
                    LangData={props.LangData}
                    SelectedJPAType={SelectedJPAType}
                    Data={TableData}
                    TableIsEmpty={StatusTableIsEmpty}
                    FetchData={(Size, Start, JPAType, Enum) =>
                      fetchStatusTableData(Size, Start, JPAType, Enum)
                    }
                    TotalElements={TotalElements}
                    SortIds={StatusSortIds}
                    ToggleExport={() => toggleExportStatus()}
                    StatusIsActive={StatusIsActive}
                    SelectedEnum={SelectedEnum}
                    SaveJPAType={(JPAType) => setSelectedJPAType(JPAType)}
                    StatusEnums={StatusEnums}
                    FilterJPA={FilterJPA}
                    setFilterJPA={setFilterJPA}
                    FilterHiringManager={FilterHiringManager}
                    setFilterHiringManager={setFilterHiringManager}
                  />
                )}
              </>
            ) : (
              <DataTable
                LangData={props.LangData}
                SelectedJPAType={SelectedJPAType}
                Data={TableData}
                TableIsEmpty={TableIsEmpty}
                FetchData={(Size, Start, JPAType, isInitial, criteria) =>
                  fetchAvailableJPATableData(Size, Start, JPAType, isInitial, criteria)
                }
                TotalElements={TotalElements}
                SortIds={JPASortIds}
                ToggleExport={() => toggleExport()}
                SetTableIsEmpty={(Bool) => setTableIsEmpty(Bool)}
                StatusIsActive={StatusIsActive}
                FilterJPA={FilterJPA}
                setFilterJPA={setFilterJPA}
                FilterHiringManager={FilterHiringManager}
                setFilterHiringManager={setFilterHiringManager}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default HRAdminDashboard;
